import { useEffect } from "react";
import { Container, Paper, Typography, Divider, Grid } from "@material-ui/core";
import useStyles from "./styles";

function Contact() {
  const classes = useStyles();
  useEffect(() => {
    document.title = "Contact us";
  }, []);

  return (
    <Container maxWidth={false}>
      <Grid container spacing={3} className={classes.pageContainer}>
        <Grid item sm={6} xs={12}>
          <Paper className={classes.infoContainer}>
            <Typography variant="h5" className={classes.headerTitle}>
              Google Maps
            </Typography>
            <Divider className={classes.dividerStyle} />
            <iframe
              title="Google Maps"
              className={classes.googleMaps}
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3201.9964666428486!2d-4.498845185225655!3d36.626471685160226!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xd72fbec12d3882f%3A0x3bab8df620f84a43!2sCalle%20Centurion%20y%20Cordoba%2C%2010%2C%2029620%20Torremolinos%2C%20M%C3%A1laga!5e0!3m2!1sen!2ses!4v1614787585125!5m2!1sen!2ses"
              allowFullScreen=""
              loading="lazy"
            >
              Loading...
            </iframe>
            <div className={classes.contentContainer}>
              <Typography variant="body1" className={classes.contentText}>
                Email: kreative.i123@gmail.com
              </Typography>
              <Typography variant="body1" className={classes.contentText}>
                Address: Calle Centurión y Córdoba, 10, 1ºA, 29620, Torremolinos
                (Málaga)
              </Typography>
            </div>
          </Paper>
        </Grid>
        <Grid item sm={6} xs={12}>
          <Paper className={classes.infoContainer}>
            <Typography variant="h5" className={classes.headerTitle}>
              Formulario
            </Typography>
            <Divider className={classes.dividerStyle} />
            <iframe
              title="Google Forms"
              src="https://docs.google.com/forms/d/e/1FAIpQLSdec76f5jtH0FHXaAEy9JJn3xOsagp8miTtpvYpCpOQaZAosA/viewform?embedded=true"
              className={classes.googleForms}
              frameBorder="0"
              marginHeight="0"
              marginWidth="0"
            >
              Loading…
            </iframe>
          </Paper>
        </Grid>
      </Grid>
    </Container>
  );
}

export default Contact;
